import React, { Suspense } from 'react'

const PayoutsPageBase = React.lazy(() => import('./Payouts'))

export const PayoutsPage = () => (
  <Suspense fallback={null}>
    <PayoutsPageBase />
  </Suspense>
)
